import Axios from "axios"
import toastr from "toastr"
import QueryString from "query-string"
import "toastr/build/toastr.min.css"

export const requestRolesListByFilters = async ({ payload }) => {
  try {
    const filters = payload
    const offset = payload["currentPage"] ? payload["currentPage"] - 1 : 0
    const limit = payload["pageSize"] || 10
    _.unset(filters, "currentPage")
    let data = await Axios.post(
      `/api/roles/getRolesByFilters?offset=${offset}&limit=${limit}`,
      { filters: payload }
    )
    return data
  } catch (error) {
    throw error
  }
}

export const requestUpsertRoles = async payload => {
  const { action } = payload.query
  try {
    if (action === "create") {
      const response = await Axios.post(
        `/api/roles/create?${QueryString.stringify(payload.query)}`,
        payload.formData
      )
      const { data = {} } = response
      if (data && data.code === 400 && data.message === "Role already exists") {
        toastr.error("Role Already Exists")
        return
      } else {
        toastr.success("Action successfull!!")
        return data
      }
    } else {
      const data = await Axios.put(
        `/api/roles/update?${QueryString.stringify(payload.query)}`,
        payload.formData
      )
      toastr.success("Action Successful !!")
      return data
    }
  } catch (error) {
    throw error
  }
}

export const requestDeleteAppRoles = async payload => {
  try {
    const data = await Axios.delete(`/api/roles/delete?roleId=${payload.id}`)
    toastr.success("Action Successful !!")
    return data
  } catch (error) {
    throw error
  }
}
